














import VueFramework from 'vue'
import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import ChannelApi from "../../repository/ChannelApi";
@Component({
    components: {


    },
    name: 'DeleteChannelModal',
})
export default class DeleteChannelModal extends Vue{
    @Prop({ default: false })showDialog!:boolean
    @Prop({ default: '' })channelName!:string
    @Prop({ default: '' })channelId!:string
    channelApi: ChannelApi = new ChannelApi()
    closeModal(){
        this.$emit('cancelModal')
    }
    async deleteChannel(){
        let response = await this.channelApi.deleteChannel(this.channelId)
        this.$emit('onChannelDeleted', response)
    }
}
